import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import CreateDepositPromotionListing from '@/modules/promotion/components/CreateDepositPromotion/components/CreateDepositPromotionListing'

function CreateDepositPromotionPage() {
	return (
		<PageContainer>
			<CreateDepositPromotionListing />
		</PageContainer>
	)
}

const GuardedCreateDepositPromotionPage = withUserPermission(
	CreateDepositPromotionPage,
	{
		permissionType: PermissionType.Write,
		permissionKey: [PermissionKeys.MANAGE_DEPOSIT_PROMOTION],
	},
)

export default GuardedCreateDepositPromotionPage
